import { LoginForm, LoginRequest } from "@/ServerTypes/Membership";
import { Texts } from "@/ServerTypes/Texts";
import { PropertyPanel } from "@serenity-is/corelib";
import { ErrorHandling, isEmptyOrNull, notifyError, parseQueryString, resolveUrl, serviceCall, ServiceResponse, localText, htmlEncode, Authorization } from "@serenity-is/corelib/q";

$(function () {
    var loginPanel = new LoginPanel($('#LoginPanel')).init();
    loginPanel.element.find('.forgot-password').appendTo('.field.Password');

    if ((document.getElementById('IsPublicDemo') as HTMLInputElement)?.value) {
        loginPanel["byId"]('Username').val('admin').attr('placeholder', 'admin')
        loginPanel["byId"]('Password').val('serenity').attr('placeholder', 'serenity');
    }

    if ((document.getElementById('Activated') as HTMLInputElement)?.value) {
        loginPanel["byId"]('Username').val((document.getElementById('Activated') as HTMLInputElement)?.value);
        loginPanel["byId"]('Password').focus();
    }
});

class LoginPanel extends PropertyPanel<LoginRequest, any> {

    protected getFormKey() { return LoginForm.formKey; }

    constructor(container: JQuery) {
        super(container);

        this.byId('LoginButton').click(e => {
            e.preventDefault();

            if (!this.validateForm())
                return;

            var request = this.getSaveEntity();

            serviceCall({
                url: resolveUrl('~/Account/Login'),
                request: request,
                onSuccess: () => {
                    this.redirectToReturnUrl();
                },
                onError: (response: ServiceResponse) => {
                    if (response != null && response.Error != null && response.Error.Code == "RedirectUserTo") {
                        window.location.href = response.Error.Arguments;
                        return;
                    }

                    if (response != null && response.Error != null && !isEmptyOrNull(response.Error.Message)) {
                        notifyError(response.Error.Message);
                        $('#Password').focus();

                        return;
                    }

                    ErrorHandling.showServiceError(response.Error);
                }
            });
        });
    }

    protected redirectToReturnUrl() {
        var q = parseQueryString();
        var returnUrl = q['returnUrl'] || q['ReturnUrl'];
        if (returnUrl) {
            var hash = window.location.hash;
            if (hash != null && hash != '#')
                returnUrl += hash;
            window.location.href = returnUrl;
        }
        else {


            // Adesso devo inviare utente registrato sulla pagina di accesso e fare verifica se ho completato i dati di registrazione

            //var autorizzazione = Authorization.username.toString();

           
        
               
                    window.location.href = resolveUrl('~/');
             

         
         

            //else if (Authorization.username == "Admin")
            //{

            //    window.location.href = resolveUrl('~/');
            //}
            
        }
    }





    protected getTemplate() {
        return `

        	<div class="limiter">
		<div class="container-login100" >
			<div class="wrap-login100">
				<div class="login100-form validate-form">
					<span class="login100-form-logo">
						<img src="${resolveUrl("~/Content/welcomeTemplate/assets/images/logo.png")}"
           
            width="100" height="100" />
					</span>

					<span class="login100-form-title p-b-34 p-t-27">
						${htmlEncode(Texts.Forms.Membership.Login.LoginToYourAccount)}
					</span>

					<div class="wrap-input100 validate-input" style="background:trasparent;" data-validate = "Inserisci username">
						<input class="input100" type="text" name="username" placeholder="Username" id="username_Personalized">
						<span class="focus-input100" data-placeholder="&#xf207;"></span>
					</div>

					<div class="wrap-input100 validate-input" data-validate="Inserisci password">
						<input class="input100" type="password" style="background:trasparent !important;" name="pass" id="password_Personalized"  placeholder="Password">
                        <span class="focus-input100" data-placeholder="&#xf191;"></span>
                        <i class='fa fa-eye' style='-webkit-user-select: none; font-size: x-large;' onmouseover='this.style.cursor = "pointer"' onmouseout='this.style.cursor = "default"' onclick='cambiaVisibilita(this)'></i>
					</div>

					<div class="contact100-form-checkbox" style="display:none;">
						<input class="input-checkbox100" id="ckb1" type="checkbox" name="remember-me" >
						<label class="label-checkbox100" for="ckb1">
							Remember me
						</label>
                      
					</div>

					<div class="container-login100-form-btn">
						<button class="login100-form-btn" onclick="eseguiFormLogin();" onkeypress="handleKeyPress(event)">
							Accedi
						</button>
					</div>

					<div class="text-center p-t-90">
						<a class="txt1" href="ForgotPassword">
							Password Dimenticata?
						</a>

                        <br />
                        <br />

                        <a class="txt1" href="SignUp">
							Non hai le credenziali? Iscriviti
						</a>
					</div>
                    <div class="pull-right p-t-90">
						 <a href="../../" class="txt1">
		                    Home Page
	                    </a>
                       
					</div>
                    
				</div>
			</div>
		</div>
	</div>
	

	<div id="dropDownSelect1"></div>

<div id="serenity_form" style="display:none;">
    <h2 class="text-center p-4">
        <img src="${resolveUrl("~/Content/site/images/serenity-logo-w-128.png")}"
            class="rounded-circle p-1" style="background-color: var(--s-sidebar-band-bg)"
            width="50" height="50" /> Marina Militare
            </h2>

    <div class="s-Panel p-4">
        <h5 class="text-center my-4">${htmlEncode(Texts.Forms.Membership.Login.LoginToYourAccount)}</h5>
        <form id="~_Form" action="">
            <div id="~_PropertyGrid"></div>
            <div class="px-field">
            </div>
            <div class="px-field">
                <button id="~_LoginButton" type="submit" class="btn btn-primary my-3 w-100">
                    ${htmlEncode(Texts.Forms.Membership.Login.SignInButton)}
                </button>
             
            </div>
        </form>
    </div>

    <div class="text-center mt-2">
    </div>   
</div>


<script>
    document.body.addEventListener('keydown', function(event) {
        if (event.keyCode === 13) {
           eseguiFormLogin();
        }
    });

    var visibilita = 1;

    function handleKeyPress(event) {
        if (event.keyCode === 13) {
          eseguiFormLogin();
        }
    }

    function cambiaVisibilita(el){
        if(visibilita == 1){
            visibilita = 0;
            el.classList.remove('fa-eye');
            el.classList.add('fa-eye-slash');
            document.getElementById('password_Personalized').type = 'text';
        }
        else{
            visibilita = 1;
            el.classList.add('fa-eye');
            el.classList.remove('fa-eye-slash');
            document.getElementById('password_Personalized').type = 'password';
        }
    }

    function eseguiFormLogin(){

        var controllo_user = document.getElementById('username_Personalized').value;
        var controllo_pwd = document.getElementById("password_Personalized").value;

        if(controllo_user == "" || controllo_pwd == ""){

            if(controllo_user == ""){
                 var thisAlert = $("#username_Personalized").parent();
                 $(thisAlert).addClass('alert-validate');
            }
            if(controllo_pwd == ""){
                 var thisAlert = $("#password_Personalized").parent();
                 $(thisAlert).addClass('alert-validate');
            }

       
        }
        else{
            document.getElementById("LoginPanel0_Username").value = document.getElementById("username_Personalized").value;
            document.getElementById("LoginPanel0_Password").value = document.getElementById("password_Personalized").value;

            document.getElementById("LoginPanel0_LoginButton").click();
        }
        

    }
</script>

<!--===============================================================================================-->
<script src="../../../Content/newLogin/vendor/animsition/js/animsition.min.js"></script>
<!--===============================================================================================-->
<script src="../../../Content/newLogin/vendor/bootstrap/js/popper.js"></script>
<script src="../../../Content/newLogin/vendor/bootstrap/js/bootstrap.min.js"></script>
<!--===============================================================================================-->
<script src="../../../Content/newLogin/vendor/select2/select2.min.js"></script>
<!--===============================================================================================-->
<script src="../../../Content/newLogin/vendor/daterangepicker/moment.min.js"></script>
<script src="../../../Content/newLogin/vendor/daterangepicker/daterangepicker.js"></script>
<!--===============================================================================================-->
<script src="../../../Content/newLogin/vendor/countdowntime/countdowntime.js"></script>
<!--===============================================================================================-->
<script src="../../../Content/newLogin/js/main.js"></script>

`;
    }
}